<template>
  <section class="hero">
    <div class="container">
      <div class="hero-content">
        <h2>{{ siteData.site.name }} | Learning</h2>
        <p>"Why just buy electronics when you can build them? Learn to create the future with {{ siteData.site.name }} Academy."</p>
        <router-link to="/docs" class="btn-primary"> <i class="fas fa-file-text"></i> DOCUMANTATION</router-link>
      </div>
    </div>
  </section>
</template>

<script>
import site from '@/../public/site.json';

export default {
  name: 'HeroSection',
  computed: {
    siteData() {
      return site;
    }
  }
}
</script>

<style scoped>
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../../assets/images/hero-img.gif');
  /* height=500&width=1200 */
  background-size: cover;
  background-position: center;
  color: var(--white);
  padding: 80px 0;
  text-align: center;
}

.hero-content {
  max-width: 600px;
  margin: 0 auto;
}

.hero h2 {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;
}

.hero p {
  font-size: 20px;
  margin-bottom: 30px;
}

@media (max-width: 576px) {
  .hero h2 {
    font-size: 36px;
  }

  .hero p {
    font-size: 16px;
  }
}
</style>